
/**
 * Get test distances for Level 1 tests
 */
export const getTestDistances = (testId: string): Record<string, string> => {
  console.log("Level1Service.getTestDistances called for:", testId);
  
  // Bunker tests with fixed distances
  if (testId === "bunker-court") {
    return {
      "G": "5m",
      "H": "8m",
      "I": "12m"
    };
  } else if (testId === "bunker-long") {
    return {
      "G1": "15m",
      "H1": "20m",
      // Points G et H pour compatibilité avec le système de scoring
      "G": "15m",
      "H": "20m"
    };
  }
  
  // Iron tests with fixed distances - utiliser seulement le point G pour correspondre aux points de navigation
  if (testId === "iron-long") {
    return { "G": "150m" };
  } else if (testId === "iron-mid") {
    return { "G": "120m" };
  } else if (testId === "iron-green-attack") {
    return { "G": "120m" };
  } else if (testId === "iron-green-attack-100") {
    return { "G": "100m" };
  }

  // Fairway wood tests with fixed distances - fairwayWood-3 utilise maintenant le point G
  if (testId === "fairwayWood-3") {
    return { "G": "200m" };
  } else if (testId === "fairwayWood-5") {
    return { "G": "180m" };
  }

  // Driver tests with fixed distances - driver-practice utilise maintenant seulement le point G avec 220m
  if (testId === "driver-practice") {
    return { "G": "220m" };
  } else if (testId === "driver-accuracy") {
    return { "G": "220m" };
  }

  // Wedging tests with progressive distances
  if (testId === "wedging-cercles") {
    return { 
      "G": "60m", 
      "H": "80m", 
      "I": "100m",
      "WedgingA": "60m",
      "WedgingB": "80m",
      "WedgingC": "100m"
    };
  } else if (testId === "wedging-pente-gauche") {
    return { 
      "G1": "60m", 
      "H1": "80m", 
      "I1": "100m",
      "WedgingA1": "60m",
      "WedgingB1": "80m",
      "WedgingC1": "100m" 
    };
  } else if (testId === "wedging-mid") {
    return { 
      "G2": "75m", 
      "H2": "85m", 
      "I2": "95m",
      "WedgingA2": "75m",
      "WedgingB2": "85m",
      "WedgingC2": "95m",
      "WedgingD": "75m",
      "WedgingE": "85m",
      "WedgingF": "95m"
    };
  }

  // Putting tests with fixed distances
  if (testId === "putts-plat") {
    return { "G": "6m", "H": "10m", "I": "12m" };
  } else if (testId === "putts-montee") {
    return { "G1": "6m", "H1": "10m", "I1": "12m" };
  } else if (testId === "putts-descente") {
    return { "G2": "6m", "H2": "10m", "I2": "12m" };
  } else if (testId === "putts-pente") {
    return { "G3": "6m", "H3": "10m", "I3": "12m" };
  } else if (testId === "putts-pente-droite") {
    return { "G4": "6m", "H4": "10m", "I4": "12m" };
  }

  // Chipping tests with progressive distances
  if (testId === "chipping-plat") {
    return { "G": "20m", "H": "30m", "I": "40m" };
  } else if (testId === "chipping-pente-droit") {
    return { "G1": "20m", "H1": "30m", "I1": "40m" };
  } else if (testId === "chipping-roulee-plat") {
    return { "G2": "10m", "H2": "20m", "I2": "30m" };
  }
  
  console.log("Level1Service.getTestDistances returning empty for:", testId);
  return {};
};
